export var GroupsActions;
(function (GroupsActions) {
    GroupsActions["CREATE"] = "Create";
    GroupsActions["UPDATE"] = "Update";
    GroupsActions["DELETE"] = "Delete";
    GroupsActions["ADD_MEMBERS"] = "AddMembers";
    GroupsActions["DELETE_MEMBERS"] = "DeleteMembers";
})(GroupsActions || (GroupsActions = {}));
